import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  PoButtonModule,
  PoDynamicFormComponent,
  PoDynamicFormField,
  PoModalComponent,
  PoModalModule,
} from '@po-ui/ng-components';
import { PoDynamicModule } from '@po-ui/ng-components';
import { ExportsService } from '../../../services/api/export.service';

@Component({
  selector: 'app-export-modal',
  standalone: true,
  imports: [
    PoButtonModule,
    PoModalModule,
    PoDynamicModule,
  ],
  templateUrl: './export-modal.component.html',
})
export class ExportModalComponent implements OnInit  {
  @Input() urlApi = '';
  @Input() formFields: PoDynamicFormField[] = [];
  @Input() defaultFormValues?: Record<string, any> = {};

  constructor(
    private exportsService: ExportsService
  ) {}

  ngOnInit() {
    this.exportFormFields = this.formFields
    this.exportFormValues = this.defaultFormValues || {}
  }

  @ViewChild('dynamicFormExport', { static: true }) dynamicFormExport!: PoDynamicFormComponent;
  @ViewChild('modalExport', { static: true }) modalExport!: PoModalComponent;
  validateFields: Array<string> = this.formFields.map(field => field.property);

  exportFormFields: PoDynamicFormField[] = []
  exportFormValues: any = {}
  
  
  handleExport() {
    const someFieldInvalid = this.formFields.some(field => {
      return !this.exportFormValues[field.property]
    })
    if(someFieldInvalid) return
    
    const paramsFormmated = Object.fromEntries(
      Object.entries(this.exportFormValues).map(([key, value]) => [key, String(Array.isArray(value) ? value.join(",") : value)])
    )
    this.exportsService.exportData({
      url: this.urlApi,
      params: paramsFormmated
    });
    this.dynamicFormExport.form.resetForm({ filters: ['all'] })
    this.modalExport.close()
  }
}
